import React, { useEffect, useState } from 'react';
import { 
  Container, 
  Table, 
  TableHead, 
  TableBody, 
  TableCell, 
  TableRow, 
  Button, 
  TextField, 
  Select, 
  MenuItem, 
  Grid,
  Paper,
  Typography,
  Box,
  Divider
} from '@mui/material';
import { styled } from '@mui/material/styles';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

// Estilos personalizados
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
}));

const SummaryCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
}));

// Función para obtener el primer día del mes actual
const getFirstDayOfMonth = () => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
};

// Función para obtener la fecha actual
const getCurrentDate = () => {
  return new Date().toISOString().split('T')[0];
};

function ReporteCajaConAPI() {
  const [datosReporte, setDatosReporte] = useState([]);
  const [fechaInicio, setFechaInicio] = useState(getFirstDayOfMonth());
  const [fechaFin, setFechaFin] = useState(getCurrentDate());
  const [filtroSala, setFiltroSala] = useState("");
  const [filtroCaja, setFiltroCaja] = useState("");
  const [opcionesSalas, setOpcionesSalas] = useState([]);
  const [opcionesCajas, setOpcionesCajas] = useState([]);
  const [filtroTexto, setFiltroTexto] = useState("");
  const [resumen, setResumen] = useState({
    totalFacturas: 0,
    clientesConNIT: 0,
    clientesCF: 0,
    montoTotal: 0,
    facturasActivas: 0,
    facturasAnuladas: 0,
    cajasQueCobraron: 0
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);

  // Función para parsear el string JSON que viene en datos_Generados
  const parseDatosGenerados = (datosGenerados) => {
    try {
      // Primero intentamos parsear directamente
      return JSON.parse(datosGenerados);
    } catch (firstError) {
      try {
        // Si falla, intentamos limpiar el string
        const datosLimpios = datosGenerados
          .replace(/\\"/g, '"')
          .replace(/\\'/g, "'")
          .replace(/\\\\/g, "\\")
          .replace(/^"|"$/g, ''); // Eliminar comillas al inicio y final si existen
        
        return JSON.parse(datosLimpios);
      } catch (secondError) {
        console.error("Error al parsear datos_Generados:", secondError);
        console.error("Contenido problemático:", datosGenerados.slice(0, 200) + "...");
        throw new Error("No se pudo parsear los datos generados");
      }
    }
  };

  // Función para obtener datos del reporte desde la API
  const fetchData = () => {
    setLoading(true);
    setError(null);
    setApiResponse(null);
    
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321"
      },
      Usr: {
        Codigo: "2150",
        UserNickName: "pierril"
      },
      DatosMetodo: {
        NombreMetodo: "ListaReportesSalas",
        Datos_Recibidos: `{"Vista":"ClientesAtendidos", "FechaIni":"${fechaInicio}","FechaFin":"${fechaFin}"}`
      }
    };
  
    console.log("Datos enviados a la API:", datos);
  
    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;
    
    fetch(fetchDataUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      return response.text();
    })
    .then(text => {
      try {
        const data = JSON.parse(text);
        setApiResponse(data); // Guardar la respuesta completa de la API
        
        if (!data || !data.datos_Generados) {
          throw new Error("La respuesta no contiene datos_Generados");
        }
        
        console.log("Respuesta completa de la API:", data);
        
        // Parseamos los datos generados que vienen como string
        const datosGenerados = parseDatosGenerados(data.datos_Generados);
        console.log("Datos generados parseados:", datosGenerados);
        
        if (!Array.isArray(datosGenerados)) {
          throw new Error("Los datos generados no son un array");
        }
        
        // Procesar los datos para el resumen
        const totalFacturas = datosGenerados.reduce((sum, item) => sum + item.Facturas_Emitidas, 0);
        const clientesConNIT = datosGenerados.reduce((sum, item) => sum + item.Clientes_Con_NIT, 0);
        const clientesCF = datosGenerados.reduce((sum, item) => sum + item.Clientes_CF, 0);
        const montoTotal = datosGenerados.reduce((sum, item) => sum + item.Total_Vendido, 0);
        const facturasActivas = datosGenerados.reduce((sum, item) => sum + item.Facturas_Activas, 0);
        const facturasAnuladas = datosGenerados.reduce((sum, item) => sum + item.Facturas_Anuladas, 0);
        const cajasQueCobraron = datosGenerados.reduce((sum, item) => sum + item.Cajas_Que_Cobraron, 0);
        
        setResumen({
          totalFacturas,
          clientesConNIT,
          clientesCF,
          montoTotal,
          facturasActivas,
          facturasAnuladas,
          cajasQueCobraron
        });
        
        // Formatear datos para la tabla
        const datosFormateados = datosGenerados.map(item => ({
          Fecha: item.DocDate.split('T')[0],
          Sala: item.Sala,
          Caja: item.Caja,
          CajasQueCobraron: item.Cajas_Que_Cobraron,
          FacturasEmitidas: item.Facturas_Emitidas,
          ClientesConNIT: item.Clientes_Con_NIT,
          ClientesCF: item.Clientes_CF,
          FacturasActivas: item.Facturas_Activas,
          FacturasAnuladas: item.Facturas_Anuladas,
          TotalVendido: item.Total_Vendido.toFixed(2),
          FechaOrden: new Date(item.DocDate)
        })).sort((a, b) => a.FechaOrden - b.FechaOrden);
        
        setDatosReporte(datosFormateados);
        
        // Actualizar opciones de salas para el filtro
        const salasUnicas = [...new Set(datosGenerados.map(item => item.Sala))];
        setOpcionesSalas(salasUnicas);
        
        // Actualizar opciones de cajas para el filtro
        const cajasUnicas = [...new Set(datosGenerados.map(item => item.Caja))];
        setOpcionesCajas(cajasUnicas);
        
        setLoading(false);
      } catch (error) {
        console.error("Error procesando respuesta:", error);
        setError(`Error al procesar los datos: ${error.message}`);
        setLoading(false);
      }
    })
    .catch(error => {
      console.error('Error en la solicitud:', error);
      setError(`Error al obtener datos: ${error.message}`);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (fechaInicio && fechaFin) {
      fetchData();
    }
  }, [fechaInicio, fechaFin]);

  // Actualizar las cajas disponibles cuando cambia la sala seleccionada
  useEffect(() => {
    if (filtroSala && datosReporte.length > 0) {
      const cajasFiltradas = [...new Set(
        datosReporte
          .filter(item => item.Sala === filtroSala)
          .map(item => item.Caja)
      )];
      setOpcionesCajas(cajasFiltradas);
      setFiltroCaja(""); // Resetear el filtro de caja al cambiar sala
    } else {
      const todasLasCajas = [...new Set(datosReporte.map(item => item.Caja))];
      setOpcionesCajas(todasLasCajas);
    }
  }, [filtroSala, datosReporte]);

  const handleSearch = () => {
    if (!fechaInicio || !fechaFin) {
      setError("Debe seleccionar ambas fechas");
      return;
    }
    fetchData();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    
    // Encabezado con resumen
    doc.setFontSize(16);
    doc.text("CLIENTES ATENDIDOS", 105, 15, null, null, 'center');
    doc.setFontSize(10);
    doc.text(`Período: ${fechaInicio} al ${fechaFin}`, 105, 22, null, null, 'center');
    doc.text(`Total Facturas: ${resumen.totalFacturas} | Cajas: ${resumen.cajasQueCobraron}`, 105, 28, null, null, 'center');
    doc.text(`Clientes NIT: ${resumen.clientesConNIT} | CF: ${resumen.clientesCF}`, 105, 34, null, null, 'center');
    doc.text(`Monto Total: Q${resumen.montoTotal.toFixed(2)} | Activas: ${resumen.facturasActivas} | Anuladas: ${resumen.facturasAnuladas}`, 105, 40, null, null, 'center');
    
    // Tabla principal
    doc.autoTable({
      startY: 46,
      head: [['Fecha', 'Sala', 'Caja', 'Facturas', 'NIT', 'CF', 'Activas', 'Anuladas', 'Total']],
      body: datosReporte.map(row => [
        row.Fecha, 
        row.Sala,
        row.Caja,
        row.FacturasEmitidas,
        row.ClientesConNIT,
        row.ClientesCF,
        row.FacturasActivas,
        row.FacturasAnuladas,
        `Q${row.TotalVendido}`
      ]),
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    doc.save(`reporte-salas-${fechaInicio}-${fechaFin}.pdf`);
  };

  const exportToExcel = () => {
    // Verificar si hay datos filtrados
    if (datosFiltrados.length === 0) {
      alert("No hay datos para exportar con los filtros actuales");
      return;
    }
  
    // Crear hoja de detalle - replicando exactamente lo que muestra la tabla
    const datosExcel = datosFiltrados.map(row => ({
      'Fecha': row.Fecha,
      'Sala': row.Sala,
      'Caja': row.Caja,
      'Facturas': row.FacturasEmitidas,
      'NIT': row.ClientesConNIT,
      'CF': row.ClientesCF,
      'Activas': row.FacturasActivas,
      'Anuladas': row.FacturasAnuladas,
      'Total': parseFloat(row.TotalVendido) // Aseguramos que es un número
    }));
  
    const wsDetalle = XLSX.utils.json_to_sheet(datosExcel);
  
    // Añadir formato de moneda a la columna Total (columna I, índice 8)
    const range = XLSX.utils.decode_range(wsDetalle['!ref']);
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const cell_address = { c: 8, r: R }; // Columna I (8) es Total
      const cell_ref = XLSX.utils.encode_cell(cell_address);
      if (!wsDetalle[cell_ref]) continue;
      wsDetalle[cell_ref].t = 'n'; // Tipo numérico
      wsDetalle[cell_ref].z = '"Q"#,##0.00'; // Formato de moneda
    }
  
    // Crear el libro de Excel con solo la hoja de detalle
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, wsDetalle, "Detalle");
  
    // Generar nombre de archivo
    let nombreArchivo = `reporte-clientes-${fechaInicio}-${fechaFin}`;
    if (filtroSala) nombreArchivo += `-${filtroSala}`;
    if (filtroCaja) nombreArchivo += `-${filtroCaja}`;
  
    XLSX.writeFile(workbook, `${nombreArchivo}.xlsx`);
  };
  // Filtrar los datos por los filtros seleccionados
  const datosFiltrados = datosReporte.filter(row => {
    const cumpleFiltroSala = filtroSala === "" || row.Sala === filtroSala;
    const cumpleFiltroCaja = filtroCaja === "" || row.Caja === filtroCaja;
    const cumpleFiltroTexto = filtroTexto === "" || 
      row.Sala.toLowerCase().includes(filtroTexto.toLowerCase()) ||
      row.Fecha.toLowerCase().includes(filtroTexto.toLowerCase()) ||
      row.Caja.toLowerCase().includes(filtroTexto.toLowerCase());
    return cumpleFiltroSala && cumpleFiltroCaja && cumpleFiltroTexto;
  });

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          CLIENTES ATENDIDOS
        </Typography>
        <Box>
          <Button 
            variant="contained" 
            onClick={exportToPDF} 
            disabled={loading || datosReporte.length === 0}
            sx={{ mr: 1, bgcolor: 'error.main', '&:hover': { bgcolor: 'error.dark' } }}
          >
            Exportar PDF
          </Button>
          <Button 
            variant="contained" 
            onClick={exportToExcel} 
            disabled={loading || datosReporte.length === 0}
            sx={{ bgcolor: 'success.main', '&:hover': { bgcolor: 'success.dark' } }}
          >
            Exportar Excel
          </Button>
        </Box>
      </Box>

      {/* Resumen */}
      <SummaryCard>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <Typography variant="h6">Facturas  <br></br> Totales</Typography>
            <Typography variant="h4">{resumen.totalFacturas}</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="h6">Clientes <br></br> NIT</Typography>
            <Typography variant="h4">{resumen.clientesConNIT}</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="h6">Clientes <br></br> CF</Typography>
            <Typography variant="h4">{resumen.clientesCF}</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="h6">Facturas <br></br> Activas</Typography>
            <Typography variant="h4">{resumen.facturasActivas}</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="h6">Facturas <br></br> Anuladas</Typography>
            <Typography variant="h4">{resumen.facturasAnuladas}</Typography>
          </Grid>
        </Grid>
      </SummaryCard>

      {/* Filtros */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={2}>
            <TextField
              label="Buscar"
              value={filtroTexto}
              onChange={(e) => setFiltroTexto(e.target.value)}
              variant="outlined"
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Select
              label="Sala"
              value={filtroSala}
              onChange={(e) => setFiltroSala(e.target.value)}
              displayEmpty
              fullWidth
              size="small"
            >
              <MenuItem value="">Todas las salas</MenuItem>
              {opcionesSalas.map((sala, index) => (
                <MenuItem key={index} value={sala}>{sala}</MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Select
              label="Caja"
              value={filtroCaja}
              onChange={(e) => setFiltroCaja(e.target.value)}
              displayEmpty
              fullWidth
              size="small"
              disabled={!filtroSala && opcionesSalas.length > 0}
            >
              <MenuItem value="">Todas las cajas</MenuItem>
              {opcionesCajas.map((caja, index) => (
                <MenuItem key={index} value={caja}>{caja}</MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Fecha Inicio"
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Fecha Fin"
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
        <Box sx={{ mt: 2, textAlign: 'right' }}>
          <Button 
            variant="contained" 
            onClick={handleSearch}
            disabled={loading}
            sx={{ minWidth: 120 }}
          >
            {loading ? 'Buscando...' : 'Buscar'}
          </Button>
        </Box>
      </Paper>

      {/* Mensajes de estado */}
      {error && (
        <Box sx={{ mb: 2, p: 2, backgroundColor: 'error.light', color: 'error.contrastText', borderRadius: 1 }}>
          <Typography>{error}</Typography>
        </Box>
      )}

      {loading && (
        <Box sx={{ mb: 2, p: 2, textAlign: 'center' }}>
          <Typography>Cargando datos...</Typography>
        </Box>
      )}

      {/* Tabla de resultados */}
      <Paper sx={{ overflow: 'hidden' }}>
        <Table sx={{ minWidth: 650 }} size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: 'primary.main' }}>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Sala</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Caja</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">Facturas</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">NIT</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">CF</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">Activas</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">Anuladas</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {datosFiltrados.length > 0 ? (
              datosFiltrados.map((row, index) => (
                <StyledTableRow key={index}>
                  <TableCell>{row.Fecha}</TableCell>
                  <TableCell>{row.Sala}</TableCell>
                  <TableCell>{row.Caja}</TableCell>
                  <TableCell align="right">{row.FacturasEmitidas}</TableCell>
                  <TableCell align="right">{row.ClientesConNIT}</TableCell>
                  <TableCell align="right">{row.ClientesCF}</TableCell>
                  <TableCell align="right">{row.FacturasActivas}</TableCell>
                  <TableCell align="right">{row.FacturasAnuladas}</TableCell>
                  <TableCell align="right">Q{row.TotalVendido}</TableCell>
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  {apiResponse && apiResponse.datos_Generados ? (
                    <Typography>Datos Generados: {apiResponse.datos_Generados}</Typography>
                  ) : loading ? (
                    'Cargando datos...'
                  ) : (
                    'No hay datos disponibles para los filtros seleccionados'
                  )}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
}

export default ReporteCajaConAPI;